var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-title"},[_c('span',{attrs:{"id":"txtspan"}},[_c('p',{staticClass:"card-title-text"},[_vm._v(_vm._s(_vm.name))])]),_c('span',{attrs:{"id":"icnspan"}},[_c('i',{staticClass:"fa fa-edit edit",on:{"click":_vm.showModal}})])]),_c('div',{staticClass:"card-content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }